__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/40820d3/_next/";